export default __webpack_public_path__ + "static/media/Synthesis.e6f06fdf.png";